import Common from '../../Common';
import Queue from './wallboard/Queue';
import Theme from './wallboard/Theme';
import Token from './wallboard/Token';

export interface CompanyWallboardBody {
	name: string
	column_amount: 0 | 1 | 2
	theme: number
	theme_color: number
	timeout: number
	queues_per_page: number
	unpin?: 0 | 1 | "0" | "1"
	expanded?: 0 | 1 | "0" | "1"
}

const Wallboard = class extends Common {
	token: InstanceType<typeof Token>;
	theme: InstanceType<typeof Theme>;
	queue: InstanceType<typeof Queue>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.token = new Token(headers);
		this.theme = new Theme(headers);
		this.queue = new Queue(headers);
	}

	create = (companyId: id, body: CompanyWallboardBody) =>
		this.post(`/company/${companyId}/wallboard`, body)

	update = (companyId: id, id: id, body: CompanyWallboardBody) =>
		this.patch(`/company/${companyId}/wallboard/${id}`, body)

	read = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/wallboard/${id}`)

	browse = (companyId: id, search: any = {}) =>
		this.get(`/company/${companyId}/wallboard`, search)

	browseCommon = (companyId: id) =>
		this.get(`/company/${companyId}/wallboard/common`)

	readCommon = (companyId: id, id: id) =>
		this.get(`/company/${companyId}/wallboard/common/${id}`)

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/wallboard/${id}`)
}

export default Wallboard
